<template>
    <p class="p-l-10 p-t-10 p-b-10 fz-15 s_font_b s_bb1_cf4f s_bf">{{data.params.rightsTitle}}</p>
    <div class="navContent s_bf">
      <div class="navItem" v-for="(v,k) in data.data" :key="k">
        <img :src="v.imgUrl||require('@/assets/images/normal.png')" alt="">
        <p>{{v.name}}</p>
      </div>
    </div>
</template>
<script>
import config from '@/config'

export default {
    props: { data: Object },
    setup(){
      return{
        assetsOss:config.oss[process.env.VUE_APP_type]
      }
    }
}
</script>
<style lang="less" scoped>
.navContent {
  display: flex;
  flex-wrap: wrap;
  padding:10px 10px 0 10px;
  width: 100%;
  .navItem{
    width: 33.333%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    margin-bottom:10px;
    color: #8e8e8e;
    img{
      width: 50px;
      height: 50px;
      margin-bottom: 10px;
    }
  }
}
</style>